module.exports = __webpack_public_path__ + "static/media/14.cf9a060d.jpg";